<!-- 文章列表 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt-24 mb-24">
                <div v-if="name_id == 1">
                    <Form :model="newFormData" label-position="right" :label-width="100">
                        <div class="form-title">标题设置</div>
                        <FormItem label="大标题样式">
                            <RadioGroup v-model="newFormData.content.style_value">
                                <Radio class="mr-24" label="1">样式一</Radio>
                                <Radio class="mr-24" label="2">样式二</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="大标题"><Input v-model="newFormData.content.title" placeholder="大标题"></Input></FormItem>
                        <FormItem label="文字大小">
                            <Input v-model="newFormData.content.size" placeholder="文字大小"><span slot="append">PX</span></Input>
                        </FormItem>
                        <FormItem label="大标题颜色"><ColorPicker v-model="newFormData.content.big_title_color"/></FormItem>
                        <FormItem label="分割线颜色"><ColorPicker v-model="newFormData.content.title_border_color"/></FormItem>
                        <FormItem v-if="newFormData.content.style_value == 1" label="装饰颜色">
                            <ColorPicker v-model="newFormData.content.dec_color"/>
                        </FormItem>
                        <FormItem label="标题背景"><ColorPicker v-model="newFormData.content.title_bg_color"/></FormItem>
                        <div class="form-title">内容设置</div>
                        <FormItem label="标题颜色"><ColorPicker v-model="newFormData.content.title_color"/></FormItem>
                        <FormItem label="文字颜色"><ColorPicker v-model="newFormData.content.text_color"/></FormItem>
                        <FormItem label="是否显示时间">
                            <i-switch v-model="newFormData.content.time_value" size="large" true-color="#FF761D" :true-value="1" :false-value="0" @on-change="changeTimeValue">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem v-if="newFormData.content.time_value" label="时间颜色"><ColorPicker v-model="newFormData.content.time_color"/></FormItem>
                        <FormItem label="文章内容">
                            <Button @click="goSetUp(newFormData.articleData)">{{ newFormData.content.articleData.title ? "已选择" : "去设置" }}</Button>
                        </FormItem>
                        <div class="form-title">按钮设置</div>
                        <FormItem label="是否展开">
                            <i-switch v-model="newFormData.content.btn_value" size="large" true-color="#FF761D" :true-value="1" :false-value="0" @on-change="changeBtn">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <template v-if="newFormData.content.btn_value">
                            <FormItem label="按钮颜色"><ColorPicker v-model="newFormData.content.btn_color"/></FormItem>
                            <FormItem label="边框颜色"><ColorPicker v-model="newFormData.content.border_color"/></FormItem>
                            <FormItem label="文字颜色"><ColorPicker v-model="newFormData.content.btn_text_color"/></FormItem>
                            <FormItem label="蒙版颜色"><ColorPicker v-model="newFormData.content.mask_color"/></FormItem>
                        </template>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色"><ColorPicker v-model="newFormData.content.bg_color"/></FormItem>
                        <FormItem label="背景图">
                            <i-switch v-model="newFormData.content.bg_value" size="large" true-color="#FF761D" :true-value="1" :false-value="0" @on-change="changeBgValue">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem v-if="newFormData.content.bg_value" label="上传背景">
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img class="bg-img" v-if="newFormData.content.bg_img.picview" :src="newFormData.content.bg_img.picview"/>
                                <Icon v-else type="md-add" size="30" color="#ccc"/>
                            </div>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form :model="newFormData" label-position="right" :label-width="80">
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"><Slider v-if="newFormData.content.marginData" class="w300" show-input v-model="newFormData.content.marginData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider v-if="newFormData.content.marginData" class="w300" show-input v-model="newFormData.content.marginData.left"></Slider></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"><Slider v-if="newFormData.content.paddingData" class="w300" show-input v-model="newFormData.content.paddingData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider v-if="newFormData.content.paddingData" class="w300" show-input v-model="newFormData.content.paddingData.left"></Slider></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"><Slider v-if="newFormData.content.radiusData" class="w300" show-input v-model=" newFormData.content.radiusData.top"></Slider></FormItem>
                        <FormItem label="下圆角"><Slider v-if="newFormData.content.radiusData" class="w300" show-input v-model=" newFormData.content.radiusData.bottom"></Slider></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <!-- 文章列表 -->
        <Modal v-model="modals" title="文章列表" width="800" :mask-closable="false">
            <div class="flex-sb">
                <div>
                    <div class="header-title"> 已发布 </div>
                    <div class="header-content" v-if="articleData.length > 0">
                        <div class="article-div cursor-p" v-for="(item, index) in articleData" :key="index" @click="goInfo(item)">
                            <div class="display-flex"><div v-if="item">{{ item.title }}</div></div>
                            <img class="w22 cursor-p" src="@/assets/delete.png" @click.stop="goDel(index)"/>
                        </div>
                    </div>
                    <div class="h500" v-else></div>
                </div>
                <div>
                    <img v-if="article_active.length > 0" src="@/assets/arrow-active.png" @click="goLeft"/>
                    <img v-else src="@/assets/arrow.png"/>
                </div>
                <div>
                    <div class="add-div">
                        <div>文章库</div>
                        <Button class="theme-bc" icon="md-add-circle" type="warning" @click="goAdd(0)">新建模板库</Button>
                    </div>
                    <div class="add-divs">
                        <div class="article-div" v-for="(item, index) in articleList" :key="index">
                            <div class="display-flex">
                                <Checkbox v-model="article_id[index].value" @on-change="changeArticle(item, $event)"></Checkbox>
                                <div>{{ item.title }}</div>
                            </div>
                            <div class="display-flex">
                                <img class="w22 cursor-p" src="@/assets/info.png" @click="goAdd(1, item)"/>
                                <img class="w22 ml-12 cursor-p" src="@/assets/delete.png" @click="goDelete(item)"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 新增/编辑 -->
        <Modal v-model="add_modal" :title="add_modal_title" width="600" :mask-closable="false">
            <Form :model="addData" label-position="right" :label-width="100" >
                <FormItem label="文章标题：">
                    <Input class="w300" type="text" v-model="addData.title" placeholder="请输入文章标题"></Input>
                </FormItem>
                <FormItem class="mt-24" label="文章内容：">
                    <Input class="w300" type="textarea" v-model="addData.content" placeholder="请输入文章内容"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="canceAddlModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitAddModal">保存</Button>
            </div>
        </Modal>
        <!-- 模板详情 -->
        <Modal v-model="info_modal" title="模板详情" width="600" :mask-closable="false">
            <div>
                <div class="info-txt">{{ infoData.title }}</div>
                <div>{{ infoData.content }}</div>
            </div>
            <div slot="footer">
                <Button @click="canceInfolModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitInfoModal">使用</Button>
            </div>
        </Modal>
        <pictureLibrary 
            v-if="switch_modal" 
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
import {
    article_list,
    article_delete,
    article_save,
} from "@/api/index";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            modals: false,
            articleList: [],
            add_modal: false,
            add_modal_title: "",
            addData: { id: "", title: "", content: "" },
            articleData: [],
            article_active: [],
            info_modal: false,
            infoData: { title: "", content: "", created_at: "" },
        };
    },
    mounted() {
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        changeTimeValue(e) {
            this.newFormData.content.time_value = e;
        },
        // 去设置(文章列表)
        goSetUp(row) {
            this.articleData = row;
            this.getArticleList();
            this.modals = true;
        },
        goInfo(row) {
            this.infoData.title = row.title;
            this.infoData.content = row.content;
            this.infoData.created_at = row.created_at;
            this.info_modal = true;
        },
        goDel(i) {
            this.$delete(this.articleData, i);
        },
        goLeft() {
            this.article_active.forEach((item) => {
                this.articleData.push(item);
            });
            this.article_active = [];
            this.newFormData.articleData = this.articleData;
            // 数组重构
            var article_id = this.article_id;
            article_id = article_id.map((item) => ({
                content: item.content,
                created_at: item.created_at,
                id: item.id,
                title: item.title,
                value: false,
            }));
            this.article_id = article_id;
        },
        changeArticle(row, e) {
            if (e) {
                this.article_active.push(row);
            } else {
                const index = this.article_active.findIndex(
                    (item) => item.id === row.id
                );
                if (index !== -1) {
                    this.article_active.splice(index, 1);
                }
            }
        },
        goDelete(row) {
            article_delete({ id: row.id }).then((res) => {
                this.getArticleList();
                this.$Message.success(res.msg);
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
        },
        goAdd(index, row) {
            if (index == 0) {
                this.add_modal_title = "新增模板";
                this.addData.id = "";
                this.addData.title = "";
                this.addData.content = "";
            } else if (index == 1) {
                this.add_modal_title = "编辑模板";
                this.addData.id = row.id;
                this.addData.title = row.title;
                this.addData.content = row.content;
            }
            this.add_modal = true;
        },
        canceAddlModal() {
            this.add_modal = false;
        },
        submitAddModal() {
            article_save(this.addData).then((res) => {
                this.getArticleList();
                this.add_modal = false;
                this.$Message.success(res.msg);
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
        },
        getArticleList() {
            article_list().then((res) => {
                this.articleList = res.data;
                // 数组重构
                var article_id = res.data;
                article_id = article_id.map((item) => ({
                    content: item.content,
                    created_at: item.created_at,
                    id: item.id,
                    title: item.title,
                    value: false,
                }));
                this.article_id = article_id;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        canceInfolModal() {
            this.info_modal = false;
        },
        submitInfoModal() {
            this.info_modal = false;
            this.modals = false;
            this.newFormData.content.articleData = this.infoData;
        },
        changeBtn(e){
            this.newFormData.content.btn_value = e;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.header-title {
    margin: 0 0 12px 0;
    font-size: 16px;
    color: #484e66;
}
.header-content {
    width: 300px;
    height: 500px;
    border-radius: 5px;
    border: 1px solid #eaeaea;
    overflow-y: auto;
}
.display-flex {
    display: flex;
    align-items: center;
}
.w22 {
    width: 22px;
    height: 22px;
}
.add-div {
    margin: 0 0 12px 0;
    font-size: 16px;
    color: #484e66;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.add-divs {
    border-radius: 5px;
    border: 1px solid #eaeaea;
    width: 300px;
    height: 500px;
    overflow-y: auto;
}
.article-div {
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #EAEAEA;
}
::v-deep .ivu-form-item {
    margin-bottom: 0;
}
.h500 {
    width: 300px;
    height: 500px;
}
.info-txt {
    margin: 0 0 12px 0;
    font-size: 18px;
    color: #484e66; 
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #FF761D;
    background-color: #FF761D;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
</style>